import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';
import type { IconsType } from '../../../types/admin';
import AdminSubNav from '../../../shared/components/AdminSubNav';
import AdminHeader from '../../../shared/components/AdminHeader';
import {
  SetupAccounts,
  SetupPlatformUsers,
  SetupVendors,
  SetupUsers,
  SetupOffices,
  SetupLocations,
  SetupProducts,
  SetupCustomPricing,
  SetupCodes,
  SetupForms,
  SetupSettings,
  SetupPricingLab,
  SetupLocationLab,
} from '../../setup/pages';

interface AdminAccountsListProps {
  activeSubSection: string;
  onSubSectionChange: (subSection: string) => void;
  brand: BrandConfig;
  Icons: IconsType;
}

const AdminAccountsList: React.FC<AdminAccountsListProps> = ({ activeSubSection, onSubSectionChange, brand, Icons }) => {
  const subNavItems = [
    { key: 'accounts', label: 'Accounts' },
    { key: 'platformUsers', label: 'Platform Users' },
    { key: 'vendors', label: 'Vendors' },
    { key: 'users', label: 'Users' },
    { key: 'offices', label: 'Offices' },
    { key: 'locations', label: 'Locations' },
    { key: 'products', label: 'Products' },
    { key: 'customPricing', label: 'Custom Pricing' },
    { key: 'codes', label: 'Codes' },
    { key: 'forms', label: 'Forms' },
    { key: 'settings', label: 'Settings' },
    { key: 'pricingLab', label: 'Pricing Lab' },
    { key: 'locationLab', label: 'Location Analytics' },
  ];

  const renderSectionContent = () => {
    switch (activeSubSection) {
      case 'accounts':
        return <SetupAccounts brand={brand} Icons={Icons} />;
      case 'platformUsers':
        return <SetupPlatformUsers brand={brand} Icons={Icons} />;
      case 'vendors':
        return <SetupVendors brand={brand} Icons={Icons} />;
      case 'users':
        return <SetupUsers brand={brand} Icons={Icons} />;
      case 'offices':
        return <SetupOffices brand={brand} Icons={Icons} />;
      case 'locations':
        return <SetupLocations brand={brand} Icons={Icons} />;
      case 'products':
        return <SetupProducts brand={brand} Icons={Icons} />;
      case 'customPricing':
        return <SetupCustomPricing brand={brand} Icons={Icons} />;
      case 'codes':
        return <SetupCodes brand={brand} Icons={Icons} />;
      case 'forms':
        return <SetupForms brand={brand} Icons={Icons} />;
      case 'settings':
        return <SetupSettings brand={brand} Icons={Icons} />;
      case 'pricingLab':
        return <SetupPricingLab brand={brand} Icons={Icons} />;
      case 'locationLab':
        return <SetupLocationLab brand={brand} Icons={Icons} />;
      default:
        return <SetupAccounts brand={brand} Icons={Icons} />;
    }
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden" style={{ backgroundColor: brand.colors.bgLight }}>
      <AdminHeader title="Setup" brand={brand} Icons={Icons} />

      <AdminSubNav
        items={subNavItems}
        activeItem={activeSubSection}
        onItemChange={onSubSectionChange}
        brand={brand}
      />

      <div className="flex-1 overflow-auto p-6">
        {renderSectionContent()}
      </div>
    </div>
  );
};

export default AdminAccountsList;
